
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-4f33e1fa&scoped=true!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Cate.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Cate.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-4f33e1fa!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Cate.vue"),
  /* scopeId */
  "data-v-4f33e1fa",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/views/product/Cate.vue
// module id = 1013
// module chunks = 2